import { Switch, useRouteMatch } from "react-router-dom";
import ProtectedRoute from "components/ProtectedRoutes";

import Wallet from "./Wallet";
import WalletDetails from "./WalletDetails";
import WalletDetailsDeposit from "./WalletDeposit";
import WalletDetailsWithdraw from "./WalletWithdraw";
import WalletDetailsTransactions from "./WalletTransactions";

import FundFiatWallet from "./FundFiatWallet";
import WithdrawFiatWallet from "./WithdrawFiatWallet";
import Earn from "../Earn";

const Walletv2Root = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <ProtectedRoute exact path={path} component={Wallet} />
      <ProtectedRoute
        exact
        path={`${path}/:coin/deposit`}
        component={WalletDetailsDeposit}
      />
      <ProtectedRoute
        exact
        path={`${path}/:coin/withdraw`}
        component={WalletDetailsWithdraw}
      />
      <ProtectedRoute
        exact
        path={`${path}/:coin/transactions`}
        component={WalletDetailsTransactions}
      />

      <ProtectedRoute
        exact
        path={`${path}/:coin/transactions`}
        component={WalletDetailsTransactions}
      />

      <ProtectedRoute
        exact
        path={`${path}/fund/:coin`}
        component={FundFiatWallet}
      />
      <ProtectedRoute exact path={`${path}/earn`} component={Earn} />
      <ProtectedRoute
        exact
        path={`${path}/withdraw/:coin`}
        component={WithdrawFiatWallet}
      />
      <ProtectedRoute exact path={`${path}/:coin`} component={WalletDetails} />
    </Switch>
  );
};

export default Walletv2Root;
